/* MAG: drawer colours for Magnott. UpCart's dashboard still holds SEFA's colours, so they are overridden in its shadow root. */
(function () {
  if (window.__magCart) return;
  window.__magCart = true;
  var CSS =
    '.upcart-public-announcement{background:#ECF8FF !important;padding:9px 8px !important;border-bottom:1px solid #BCE3EE !important;}' +
    '.upcart-public-announcement,.upcart-public-announcement *{color:#121212 !important;font-weight:600 !important;}' +
    '.upcart-public-announcement p{white-space:nowrap !important;font-size:11.5px !important;margin:0 !important;}' +
    '@supports (container-type:inline-size){.upcart-public-announcement{container-type:inline-size;}.upcart-public-announcement p{font-size:min(15px,3.2cqw) !important;}}' +
    '.upcart-footer.upcart-footer.upcart-footer{background:#ECF8FF !important;border-top:1px solid #BCE3EE !important;}' +
    /* :visited on the app's button rule counts as a class, so the selector is tripled */
    '.upcart-checkout-button.upcart-checkout-button.upcart-checkout-button,.upcart-checkout-button.upcart-checkout-button.upcart-checkout-button:visited{background:#BCE3EE !important;color:#121212 !important;border-radius:8px !important;font-weight:700 !important;}' +
    '.upcart-checkout-button.upcart-checkout-button.upcart-checkout-button *{color:#121212 !important;}';
  function skin() {
    var h = document.getElementById('upCart');
    if (!h || !h.shadowRoot || h.shadowRoot.querySelector('#mag-upcart-css')) return;
    var s = document.createElement('style');
    s.id = 'mag-upcart-css';
    s.textContent = CSS;
    h.shadowRoot.appendChild(s);
  }
  setInterval(skin, 1000);
  skin();
})();
